export default __webpack_public_path__ + "static/img-app-pension--mobile-39b73f787b8d14c8d5c6c54585232915.webp";